<template>
	<div class="form__group">
		<datepicker
            v-if="disabledDates"
            :name="name"
            :monday-first="true"
            :clear-button="true"
            input-class="form__control"
            format="yyyy-MM-dd"
            @selected="selected"
            :value="date"
            placeholder="Select..."
            :disabled-dates="disabledDates"
            :open-date="openDate"
            :use-utc="true"
            @cleared="clearDate"
        />
        <datepicker
            v-else
            :name="name"
            :monday-first="true"
            :clear-button="true"
            input-class="form__control"
            format="yyyy-MM-dd"
            @selected="selected"
            :value="date"
            :use-utc="true"
            placeholder="Select..."
        />
		<label class="form__label">{{ label }}</label>
		<div class="form__validation">{{ errors.first(name) }}</div>
        <div class="form__validation" v-if="error">{{ error }}</div>
	</div>
</template>

<script>
	import Datepicker from 'vuejs-datepicker';
    import { formatInTimeZone } from 'date-fns-tz';

	export default {
		name: 'FormControlDatepicker',
		components: {
			Datepicker
		},
		props: {
			label: {
				type: String,
				default: 'From date',
			},
            error: {
                type: String,
                default: null
            },
			value: {
				type: String,
			},
            minDate: {
                type: Date,
                default: null,
            },
            maxDate: {
                type: Date,
                default: null,
            },
            name: {
                type: String
            }
		},
		data() {
			return {
				date: this.value ? this.value : null,
                // disabledDates: this.minDate.date && this.maxDate.date ? {
                //     to: this.minDate,
                //     from: this.maxDate,
                // } : null,
                disabledDates: this.minDate && this.maxDate ? {
                    to: this.minDate,
                    from: this.maxDate,
                } : null,
                openDate: this.minDate ? this.minDate : null,
			}
		},
		methods: {
			selected(selected) {
                // if is empty, clear the date and return
                if(!selected) {
                    this.date = null;
                    this.$emit('input', this.date);
                    return;
                }

                this.date = formatInTimeZone(selected, 'UTC', 'yyyy-MM-dd');
				this.$emit('input', this.date);
			},
            clearDate() {
                this.date = null;
                this.$emit('input', this.date);
            }
		},
		watch: {
			value(value) {
				console.log(value);
				if(!this.date) {
					this.date = value;
				}
			}
		}
	}
</script>
